/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'optimize': {
    width: 22,
    height: 18,
    viewBox: '0 0 22 18',
    data: '<g stroke-width=".9" _fill="none" fill-rule="evenodd"><path pid="0" d="M1.178 10.744c0-5.578 4.74-10.06 10.448-9.708 4.797.295 8.739 4.097 9.154 8.84a9.634 9.634 0 0 1-1.454 6.024c-.425.672-1.184 1.066-1.985 1.066H4.656c-.803 0-1.563-.396-1.989-1.07a9.612 9.612 0 0 1-1.489-5.152z" _stroke="#234357"/><path pid="1" d="M17.944 11.053h.76M16.069 6.033l.572-.567M11.012 3.789v-.721M5.8 6.033l-.562-.558M4.1 11.054h-.792" _stroke="#234357" stroke-linecap="round" stroke-linejoin="round"/><path pid="2" d="M12.018 12.033l4.891-3.477" _stroke="#008AFF" stroke-linecap="round" stroke-linejoin="round"/><path pid="3" d="M12.018 14.026c-.556.55-1.456.55-2.012 0a1.4 1.4 0 0 1 0-1.993 1.432 1.432 0 0 1 2.012 0 1.4 1.4 0 0 1 0 1.993z" _stroke="#008AFF"/></g>'
  }
})
